<template>
  <main-layout id="information-installation-page">

    <app-header icon="factory">
      Installation
    </app-header>

    <nav id="actions-top" class="wrap" style="display: flex; justify-content: space-between">
      <action-bar :back="{name: 'installation', params: { id: this.$route.params.id }}">

      </action-bar>

      <div v-if="installation.batiment" style="margin: auto">
        <p>Batiment : <strong style="color: #5698d2">{{ installation.batiment.nom }}</strong></p>
      </div>
    </nav>

    <form method="post" class="wrap" id="installation" @submit.prevent="sendForm()" @input="updateForm">

      <div class="wrap">
        <label>Date mise en service</label>
        <input type="date" v-model="newInformation.date_mise_en_service" :max="today" @change="updateEntretienDate($event)">
      </div>

      <div class="check" v-if="this.display.desp === false && this.installation.fluide != null" @change="updateDisplay('desp')">
        <input type="checkbox" id="id_display_desp" value="1">
        <label class="btn check" for="id_display_desp">Équipement soumis à la DESP
          <i class="icon-valid"></i>
        </label>
      </div>

      <div class="wrap" v-if="this.display.desp === true">

        <h2>DESP</h2>
        <div class="check">
          <input type="checkbox" id="is_desp" value="1" v-model="newInformation.desp.is_checked" @change="updateDesp">
          <label class="btn check" for="is_desp">Équipement soumis à la DESP
            <i class="icon-valid"></i>
          </label>
        </div>

        <label>Inspection périodique réalisée le</label>
        <input type="date" v-model="newInformation.desp.last_date" :max="today" @change="setDespLastDate($event)">

        <label>Alarme</label>
        <select v-model="newInformation.desp.alarm">
          <option value="0">Aucune</option>
          <option value="24">24 mois</option>
          <option value="48">48 mois</option>
        </select>

        <label>Commentaire</label>
        <textarea v-model="newInformation.desp.commentaire"></textarea>

        <div v-if="installation.i_tag !== null">
            <a href="javascript: void 0" class="btn btn-full photo" @click="$refs.photoDESP.click()">
                Photographier le document
                <i class="icon-photo"></i>
            </a>
            <div v-show="newInformation.desp.file !== null" class="preview-img">
                <i class="icon icon-delete" @click="newInformation.desp.file = null"></i>
                <a :href="newInformation.desp.file" title="photo de l'installation" target="_blank">
                    <img :src="newInformation.desp.file" alt="photo installation" class="photo-install">
                </a>
            </div>
            <input type="file" ref="photoDESP" v-show="false" @change="handlePhotoInstallDESP">
        </div>


      </div>

      <div class="check" v-if="this.display.maintenance === false" @change="updateDisplay('maintenance')">
        <input type="checkbox" id="is_display_maintenance" value="1">
        <label class="btn check" for="is_display_maintenance">Équipement soumis à une maintenance préventive
          <i class="icon-valid"></i>
        </label>
      </div>

      <div class="wrap" v-if="this.display.maintenance === true">

        <h2>MAINTENANCE PRÉVENTIVE</h2>
        <div class="check">
          <input type="checkbox" id="is_maintenance_preventive" value="1"
                 v-model="newInformation.maintenance.is_checked" @change="updateMaintenance">
          <label class="btn check" for="is_maintenance_preventive">Équipement soumis à une maintenance préventive
            <i class="icon-valid"></i>
          </label>
        </div>

        <label>Maintenance préventive réalisée le</label>
        <input type="date" v-model="newInformation.maintenance.last_date" :max="today" @change="setMaintenanceLastDate($event)">

        <label>Alarme</label>
        <select v-model="newInformation.maintenance.alarm">
          <option value="0">Aucune</option>
          <option value="12">12 mois</option>
          <option value="18">18 mois</option>
          <option value="24">24 mois</option>
        </select>

        <label>Commentaire</label>
        <textarea v-model="newInformation.maintenance.commentaire"></textarea>

          <div v-if="installation.i_tag !== null">
              <a href="javascript: void 0" class="btn btn-full photo" @click="$refs.photoMaintenance.click()">
                  Photographier le document
                  <i class="icon-photo"></i>
              </a>
              <div v-show="newInformation.maintenance.file !== null" class="preview-img">
                  <i class="icon icon-delete" @click="newInformation.maintenance.file = null"></i>
                  <a :href="newInformation.maintenance.file" title="photo de l'installation" target="_blank">
                      <img :src="newInformation.maintenance.file" alt="photo installation" class="photo-install">
                  </a>
              </div>
              <input type="file" ref="photoMaintenance" v-show="false" @change="handlePhotoInstallMaintenance">
          </div>


      </div>

      <div class="check" v-if="this.display.attestation === false  && this.installation.fluide != null" @change="updateDisplay('attestation')">
        <input type="checkbox" id="is_display_entretien" value="1">
        <label class="btn check" for="is_display_entretien">Équipement soumis à l'attestation d'entretien 4kW à 70 kW
          <i class="icon-valid"></i>
        </label>
      </div>

      <div class="wrap" v-if="this.display.attestation === true">

        <h2>ENTRETIEN</h2>
        <div class="check">
          <input type="checkbox" id="is_attestation_entretien" value="1" v-model="newInformation.attestation.is_checked"
                 @change="updateAttestation()">
          <label class="btn check" for="is_attestation_entretien">Équipement soumis à l'attestation d'entretien 4kW à 70
            kW
            <i class="icon-valid"></i>
          </label>
        </div>

        <label>Date de l'attestation d'entretien</label>
        <input type="date" v-model="newInformation.attestation.last_date" @change="setAttestionLastDate($event)">

        <label>Type d'équipement</label>
        <select v-model="newInformation.attestation.type_equipement">
          <option v-for="type in listTypeEquipement" :key="type" :value="type">{{ type }}</option>
        </select>

        <label>PUISSANCE CHAUD (KW)</label>
        <input type="number" v-model="newInformation.attestation.puissance_chaud">

        <label>PUISSANCE FROID (KW)</label>
        <input type="number" v-model="newInformation.attestation.puissance_froid">


        <label>Commentaire</label>
        <textarea v-model="newInformation.attestation.commentaire"></textarea>

          <div v-if="installation.i_tag !== null">
              <a href="javascript: void 0" class="btn btn-full photo" @click="$refs.photoEntretien.click()">
                  Photographier le document
                  <i class="icon-photo"></i>
              </a>
              <div v-show="newInformation.attestation.file !== null" class="preview-img">
                  <i class="icon icon-delete" @click="newInformation.attestation.file = null"></i>
                  <a :href="newInformation.attestation.file" title="photo attestion d'entretien" target="_blank">
                      <img :src="newInformation.attestation.file" alt="photo attestation d'entretien" class="photo-install">
                  </a>
              </div>
              <input type="file" ref="photoEntretien" v-show="false" @change="handlePhotoInstallEntretien">
          </div>




      </div>


      <input type="submit" id="submit-install" name="new" v-if="canEditInstallations" value="SAUVEGARDER">

    </form>

    <div class="wrap lastSaisie" v-if="lastInformation != null">
      <h2>Dernière saisie :</h2>

      <div class="blocInfos" v-if="lastInformation.desp.is_checked === true && installation.fluide !== null">
        <h3><i class="icon-valid"></i> Équipement soumis à la DESP</h3>
        <p><strong>Dernière inspection le :</strong> {{ lastInformation.desp.last_date | dateFormat }}</p>
        <p><strong>Alarme :</strong>
          {{ lastInformation.desp.alarm == 0 ? 'aucune' : lastInformation.desp.alarm + ' mois' }}</p>
        <p><strong>Commentaire :</strong> {{ lastInformation.desp.commentaire }}</p>
        <a class="btn btn-secondary"
           v-if="lastInformation.desp.file != null && isBase64(lastInformation.desp.file) === false"
           :href="`${Config.urlAdmin}/upload/${lastInformation.desp.file}`" target="_blank">Voir le document </a>
        <img v-bind:src="lastInformation.desp.file"
             v-if="lastInformation.desp.file != null && isBase64(lastInformation.desp.file) === true"
             alt="photo installation" class="photo-install">
        <p v-if="lastInformation.desp.file === null">Pas de document</p>
      </div>

      <div class="blocInfos" v-if="lastInformation.maintenance.is_checked === true">
        <h3><i class="icon-valid"></i> Équipement soumis à la maintenance préventive</h3>
        <p><strong> Maintenance préventive le :</strong> {{ lastInformation.maintenance.last_date | dateFormat }}</p>
        <p><strong>Alarme :</strong>
          {{ lastInformation.maintenance.alarm == 0 ? 'aucune' : lastInformation.maintenance.alarm + ' mois' }}</p>
        <p><strong>Commentaire :</strong> {{ lastInformation.maintenance.commentaire }}</p>
        <a class="btn btn-secondary"
           v-if="lastInformation.maintenance.file != null && isBase64(lastInformation.maintenance.file) === false"
           :href="`${Config.urlAdmin}/upload/${lastInformation.maintenance.file}`" target="_blank">Voir le document </a>
        <img v-bind:src="lastInformation.maintenance.file"
             v-if="lastInformation.maintenance.file != null && isBase64(lastInformation.maintenance.file) === true"
             alt="photo installation" class="photo-install">
        <p v-if="lastInformation.maintenance.file === null">Pas de document</p>
      </div>

      <div class="blocInfos" v-if="lastInformation.attestation.is_checked === true && installation.fluide !== null">
        <h3><i class="icon-valid"></i> Équipement soumis à l'attestion d'entretien </h3>
        <p><strong> Attestation d'entretien le :</strong> {{ lastInformation.attestation.last_date | dateFormat }}</p>
        <p><strong></strong> Type : {{ lastInformation.attestation.type_equipement }}</p>
        <p v-if="lastInformation.attestation.puissance_chaud"><strong>Puissance Chaud :</strong>
          {{ lastInformation.attestation.puissance_chaud }} kW</p>
        <p v-if="lastInformation.attestation.puissance_froid"><strong>Puissance Froid :</strong>
          {{ lastInformation.attestation.puissance_froid }} kW</p>
        <p><strong>Commentaire :</strong> {{ lastInformation.attestation.commentaire }} </p>
        <a class="btn btn-secondary"
           v-if="lastInformation.attestation.file != null && isBase64(lastInformation.attestation.file) === false"
           :href="`${Config.urlAdmin}/upload/${lastInformation.attestation.file}`" target="_blank">Voir le document </a>
        <img v-bind:src="lastInformation.attestation.file"
             v-if="lastInformation.attestation.file != null && isBase64(lastInformation.attestation.file) === true"
             alt="photo installation" class="photo-install">
        <p v-if="lastInformation.attestation.file === null">Pas de document</p>
      </div>
    </div>

  </main-layout>
</template>

<script>
import Installation from '../../js/models/Installation'
import moment from "moment";
import Config from "../../js/config";
import InformationInstallation from "../../js/models/InformationInstallation";
import loadImage from "blueimp-load-image";
import {install} from "offline-plugin/runtime";

export default {
  data() {
    return {
      installation: {
        information: {}
      },
      lastInformation: {
        date_mise_en_service: null,
        installation: null,
        desp: {
          is_checked: false,
          last_date: null,
          alarm: 0,
          commentaire: null,
          file: null
        },
        maintenance: {
          is_checked: false,
          last_date: null,
          alarm: 0,
          commentaire: null,
          file: null
        },
        attestation: {
          is_checked: false,
          last_date: null,
          type_equipement: null,
          puissance_froid: null,
          puissance_chaud: null,
          commentaire: null,
          file: null
        }
      },
      newInformation: {
        date_mise_en_service: null,
        installation: null,
        desp: {
          is_checked: false,
          last_date: null,
          alarm: 0,
          commentaire: null,
          file: null
        },
        maintenance: {
          is_checked: false,
          last_date: null,
          alarm: 0,
          commentaire: null,
          file: null
        },
        attestation: {
          is_checked: false,
          last_date: null,
          type_equipement: null,
          puissance_froid: null,
          puissance_chaud: null,
          commentaire: null,
          file: null
        }
      },
      display: {
        desp: false,
        maintenance: false,
        attestation: false
      },
      cache: {
        inCache: false,
        id: null
      },
      canEditInstallations: null,
      today: moment().format('Y-MM-DD'),
      formModified: false,
      listTypeEquipement: null
    }
  },

  computed: {
    Config() {
      return Config
    },
  },

  methods: {
    install,

    validateForm() {
      let errors = [];

      let newInformation = this.newInformation;

      if (newInformation.desp.is_checked === true) {

        if (!newInformation.desp.last_date || !newInformation.desp.alarm) {
          errors.push('<strong>DESP :</strong>');
        }

        if (!newInformation.desp.last_date) {
          errors.push('la date de la dernière inspection périodique est obligatoire');
        }

        if (!newInformation.desp.alarm) {
          errors.push('l\'alarme est obligatoire');
        }

      } else {
        newInformation.desp.is_checked = false;
        newInformation.desp.last_date = null;
        newInformation.desp.alarm = null;
        newInformation.desp.commentaire = null;
        newInformation.desp.file = null;
      }


      if (newInformation.maintenance.is_checked === true) {

        if (!newInformation.maintenance.last_date || !newInformation.maintenance.alarm) {
          errors.push('<strong>Maintenance préventive :</strong>');
        }

        if (!newInformation.maintenance.last_date) {
          errors.push('Veuillez renseigner la date de la dernière maintenance préventive');
        }

        if (!newInformation.maintenance.alarm) {
          errors.push('Veuillez renseigner l\'alarme');
        }

      } else {
        newInformation.maintenance.is_checked = false;
        newInformation.maintenance.last_date = null;
        newInformation.maintenance.alarm = null;
        newInformation.maintenance.commentaire = null;
        newInformation.maintenance.file = null;
      }


      if (newInformation.attestation.is_checked === true) {

        if (!newInformation.attestation.last_date || !newInformation.attestation.type_equipement || !newInformation.attestation.puissance_froid || !newInformation.attestation.puissance_chaud) {
          errors.push('<strong>Attestation d\'entretien :</strong>');
        }

        if (!newInformation.attestation.last_date) {
          errors.push('Veuillez renseigner la date de l\'attestation d\'entretien');
        }

        if (!newInformation.attestation.type_equipement) {
          errors.push('Veuillez renseigner le type d\'équipement');
        }

        if (!newInformation.attestation.puissance_froid) {
          errors.push('Veuillez renseigner la puissance froid');
        }

        if (!newInformation.attestation.puissance_chaud) {
          errors.push('Veuillez renseigner la puissance chaud');
        }
      } else {
        newInformation.attestation.is_checked = false;
        newInformation.attestation.last_date = null;
        newInformation.attestation.type_equipement = null;
        newInformation.attestation.puissance_froid = null;
        newInformation.attestation.puissance_chaud = null;
        newInformation.attestation.commentaire = null;
        newInformation.attestation.file = null;
      }

      newInformation.installation = this.installation.id;

      if (this.cache.inCache === true) {
        newInformation.id = this.cache.id;
      }

      return {
        errors: errors,
        newInformation: newInformation
      }
    },

    sendForm() {
      let _router = this.$router;
      let vue = this;
      let idDet = this.$route.params.id;

      let validate = this.validateForm();
      let errors = validate.errors;
      let newInformation = validate.newInformation;

      if (errors.length !== 0) {
        let text = errors.join('<br>');
        swal('Information(s) manquante(s) :', 'Veuillez renseigner <br>' + text + '.', 'error')
      } else {
        InformationInstallation
            .addInformationInstallationOffline(newInformation)
            .then(function () {
              swal('Succès', 'La saisie a bien été enregistrée', 'success').then(() => {
                //Comme le formulaire est enregistrer, on va pas mettre la popup qui dit gneugneu enregistre :clown:
                vue.formModified = false;
                _router.push({name: "installation", params: {id: idDet, idInst: newInformation.installation}})
              })
            })
      }
    },

    updateForm() {
      this.formModified = true;
    },

    handlePhotoInstallDESP(e) {
      let vueInstance = this;

      loadImage(
          e.target.files[0],
          function (img) {
            if (img instanceof Event) {
                swal('Erreur', 'Impossible de charger cette image, vérifiez le format du fichier.', 'error');
                return;
            }
            vueInstance.newInformation.desp.file = img.toDataURL();
          },
          {
            maxWidth: 700,
            maxHeight: 700,
            orientation: true,
            canvas: true
          }
      )

    },

    isBase64(str) {
      if (str === null) {
        return false;
      }
      return str.startsWith('data:');
    },

    handlePhotoInstallMaintenance(e) {
      let vueInstance = this;

      loadImage(
          e.target.files[0],
          function (img) {
            if (img instanceof Event) {
                swal('Erreur', 'Impossible de charger cette image, vérifiez le format du fichier.', 'error');
                return;
            }
            vueInstance.newInformation.maintenance.file = img.toDataURL();
          },
          {
            maxWidth: 700,
            maxHeight: 700,
            orientation: true,
            canvas: true
          }
      )

    },

    handlePhotoInstallEntretien(e) {
      let vueInstance = this;

      loadImage(
          e.target.files[0],
          function (img) {
            if (img instanceof Event) {
                swal('Erreur', 'Impossible de charger cette image, vérifiez le format du fichier.', 'error');
                return;
            }
            vueInstance.newInformation.attestation.file = img.toDataURL();
          },
          {
            maxWidth: 700,
            maxHeight: 700,
            orientation: true,
            canvas: true
          }
      )

    },

    updateDisplay(type) {
      if (type === "desp") {
        this.display.desp = true;
        this.newInformation.desp.is_checked = true;
      } else if (type === "maintenance") {
        this.display.maintenance = true;
        this.newInformation.maintenance.is_checked = true;
      } else if (type === "attestation") {
        this.display.attestation = true;
        this.newInformation.attestation.is_checked = true;
        this.newInformation.attestation.last_date = this.newInformation.date_mise_en_service
      }
    },

    updateDesp() {
      if (this.newInformation.desp.is_checked === false) {
        this.display.desp = false;
      }

      if (this.newInformation.desp.is_checked === true) {
        this.display.desp = true;
      }
    },

    updateMaintenance() {
      if (this.newInformation.maintenance.is_checked === false) {
        this.display.maintenance = false;
      }

      if (this.newInformation.maintenance.is_checked === true) {
        this.display.maintenance = true;
      }
    },

    updateAttestation() {
      if (this.newInformation.attestation.is_checked === false) {
        this.display.attestation = false;
      }

      if (this.newInformation.attestation.is_checked === true) {
        this.display.attestation = true;
      }
    },

    updateEntretienDate(event) {
      const inputValue = event.target.value;
      this.newInformation.date_mise_en_service = inputValue;
      this.newInformation.attestation.last_date = this.newInformation.date_mise_en_service;
    },
    setDespLastDate(event) {
      const inputValue = event.target.value;
      this.newInformation.desp.last_date = inputValue;
    },
    setMaintenanceLastDate(event) {
      const inputValue = event.target.value;
      this.newInformation.maintenance.last_date = inputValue;
    },
    setAttestionLastDate(event) {
      const inputValue = event.target.value;
      this.newInformation.attestation.last_date = inputValue;
    },

    fetchInstallation() {

      return new Promise((resolve, reject) => {
        let vueInstance = this;
        let idInstall = this.$route.params.idInst;

        Installation
            .getInstallation(idInstall)
            .then(res => {
              vueInstance.installation = res;

              // `return` indispensable : sans lui le .then externe se resout
              // avant la chaine interne, et le .catch ci-dessous ne voit jamais
              // ses echecs -- la promesse restait alors pendante pour toujours.
              return InformationInstallation
                  .getListByInstallation(res.id)
                  .then(function (result) {



                    if (!_.isEmpty(result)) {
                      //first key array
                      result = result.pop()


                      vueInstance.newInformation.date_mise_en_service = moment(result.date_mise_en_service).format('YYYY-MM-DD');

                      vueInstance.newInformation.desp.is_checked = result.desp.is_checked
                      vueInstance.newInformation.desp.alarm = result.desp.alarm;
                      vueInstance.newInformation.desp.last_date = moment(result.desp.last_date).format('YYYY-MM-DD');
                      vueInstance.newInformation.desp.commentaire = result.desp.commentaire;
                      vueInstance.newInformation.desp.file = result.desp.file;

                      vueInstance.newInformation.maintenance.is_checked = result.maintenance.is_checked;
                      vueInstance.newInformation.maintenance.last_date = moment(result.maintenance.last_date).format('YYYY-MM-DD');
                      vueInstance.newInformation.maintenance.alarm = result.maintenance.alarm;
                      vueInstance.newInformation.maintenance.commentaire = result.maintenance.commentaire;
                      vueInstance.newInformation.maintenance.file = result.maintenance.file;

                      vueInstance.newInformation.attestation.is_checked = result.attestation.is_checked;
                      vueInstance.newInformation.attestation.last_date = moment(result.attestation.last_date).format('YYYY-MM-DD');
                      vueInstance.newInformation.attestation.type_equipement = result.attestation.type_equipement;
                      vueInstance.newInformation.attestation.puissance_froid = result.attestation.puissance_froid;
                      vueInstance.newInformation.attestation.puissance_chaud = result.attestation.puissance_chaud;
                      vueInstance.newInformation.attestation.commentaire = result.attestation.commentaire;
                      vueInstance.newInformation.attestation.file = result.attestation.file;

                      vueInstance.cache.inCache = true;
                      vueInstance.cache.id = result.id;
                      //Cache l'historique si on a du local
                      vueInstance.lastInformation = null;

                    } else {
                        vueInstance.installation.information = {};

                        vueInstance.newInformation.date_mise_en_service = moment(vueInstance.installation.date_mise_en_service).format('YYYY-MM-DD');


                        let item = null;

                        if(vueInstance.installation.last_information_desp) {
                            item = vueInstance.installation.last_information_desp;

                            vueInstance.newInformation.desp.is_checked = item.is_checked;
                            vueInstance.newInformation.desp.last_date = moment(item.last_date).format('YYYY-MM-DD');
                            vueInstance.newInformation.desp.alarm = item.alarm;

                            vueInstance.lastInformation.desp.is_checked = item.is_checked;
                            vueInstance.lastInformation.desp.last_date = moment(item.last_date).format('YYYY-MM-DD');
                            vueInstance.lastInformation.desp.alarm = item.alarm;
                            vueInstance.lastInformation.desp.commentaire = item.commentaire;
                            vueInstance.lastInformation.desp.file = item.file;
                        }

                        if(vueInstance.installation.last_information_maintenance) {
                            item = vueInstance.installation.last_information_maintenance;

                            vueInstance.newInformation.maintenance.is_checked = item.is_checked;
                            vueInstance.newInformation.maintenance.last_date = moment(item.last_date).format('YYYY-MM-DD');
                            vueInstance.newInformation.maintenance.alarm = item.alarm;

                            vueInstance.lastInformation.maintenance.is_checked = item.is_checked;
                            vueInstance.lastInformation.maintenance.last_date = moment(item.last_date).format('YYYY-MM-DD');
                            vueInstance.lastInformation.maintenance.alarm = item.alarm;
                            vueInstance.lastInformation.maintenance.commentaire = item.commentaire;
                            vueInstance.lastInformation.maintenance.file = item.file;
                        }

                        if(vueInstance.installation.last_information_attestation) {
                            item = vueInstance.installation.last_information_attestation;

                            vueInstance.newInformation.attestation.is_checked = item.is_checked;
                            vueInstance.newInformation.attestation.last_date = moment(item.last_date).format('YYYY-MM-DD');
                            vueInstance.newInformation.attestation.type_equipement = item.type_equipement;
                            vueInstance.newInformation.attestation.puissance_froid = item.puissance_froid;
                            vueInstance.newInformation.attestation.puissance_chaud = item.puissance_chaud;

                            vueInstance.lastInformation.attestation.is_checked = item.is_checked;
                            vueInstance.lastInformation.attestation.last_date = moment(item.last_date).format('YYYY-MM-DD');
                            vueInstance.lastInformation.attestation.type_equipement = item.type_equipement;
                            vueInstance.lastInformation.attestation.puissance_froid = item.puissance_froid;
                            vueInstance.lastInformation.attestation.puissance_chaud = item.puissance_chaud;
                            vueInstance.lastInformation.attestation.commentaire = item.commentaire;
                            vueInstance.lastInformation.attestation.file = item.file;
                        }



                    }
                  }).then(() => {
                resolve(true)
              })
            })
            .catch(err => {
              reject(err)
            })
      })


    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.formModified) {
      // Des modifications non enregistrées ont été détectées, affichez la boîte de dialogue de confirmation

      swal({
        title: 'Des modifications non enregistrées ont été détectées.',
        text: "Voulez-vous enregistrer les modifications avant de quitter la page ?",
        type: 'question',
        confirmButtonText: 'Oui',
        showCancelButton: true,
        cancelButtonText: 'Non',
        allowOutsideClick: false
      }).then(
          () => {
            if (this.validateForm().errors.length === 0) {
              this.sendForm();
              next();
            } else {
              swal('Information(s) manquante(s) :', 'Veuillez renseigner <br>' + this.validateForm().errors.join('<br>') + '.', 'error');
              next(false);
            }
          },
          () => {
            next()
          }
      )
      next(false);
    } else {
      // Aucune modification détectée, poursuivez la navigation
      next();
    }
  },

  mounted: function () {

    this.canEditInstallations = JSON.parse(localStorage.getItem('canEditInstallations'));
    localforage
        .getItem('listTypesEntretien')
        .then((value) => {
          this.listTypeEquipement = JSON.parse(value);

        }, err => {
          console.error('Chargement des types d\'entretien impossible (listTypesEntretien)', err);
        })

    this.fetchInstallation().then(() => {

      if(this.installation.fluide === null) {
          //Don't display desp ou attestation si pas de fluide dans install :)
        this.display.attestation = false;
        this.newInformation.attestation.is_checked = false;
        this.display.desp = false;
        this.newInformation.desp.is_checked = false;

      }
      this.updateDesp();
      this.updateMaintenance();
      this.updateAttestation();

    }).catch(err => {
      console.error('Chargement des informations complementaires impossible', err);
      swal('Erreur', 'Impossible de charger les informations de cette installation. Réessayez, ou relancez l\'application si le problème persiste.', 'error');
      // go(-1) ne ferait rien si la page est la premiere entree d'historique
      // (rechargement direct de l'URL).
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'home' });
    })

  }
}
</script>

<style>
.check input {
  display: none;
}

.check input:checked + label {
  color: white;
  background-color: rgb(234, 94, 11);
}

.check input:checked + label i {
  color: white;
}

.check label {
  position: relative;
  background-color: #e2e2e2;
  color: #999;
  margin-bottom: 5px;
  padding: 0 10px;
  font-family: "Open Sans";
  font-size: 1.5rem;
  font-weight: 400;
  text-transform: none;
  transition: all 250ms ease;
}

.check label i {
  position: absolute;
  right: 10px;
  font-size: 2.3rem;
  color: #999;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// InformationInstallation.vue?3f8e16e6